module.exports = __webpack_public_path__ + "media/images/riders/FINN_ILES-55b7df942007e869109b76ce923e5df3.png";